import Grid from '@mui/material/Grid2';

import {
  BestTradersTemplate,
  ChallengeButtonsTemplate,
  HomeHeaderTemplate,
  LastChallengesTemplate,
  LiveChallengeTemplate,
  QuickAccessButtonTemplate,
  SectionTitleTemplate,
  ViewBalanceTemplate,
} from './components';

export const HomePageTemplate = () => (
  <Grid
    container
    spacing={2}
    className="hide-scrollbar"
    sx={{
      overflowY: 'auto',
      display: 'flex',
      fontFamily: 'Geogrotesque Wide',
      pt: 2,
      pb: '1.5rem',
    }}>
    <Grid px={2} size={12} container>
      <HomeHeaderTemplate />
    </Grid>
    <Grid px={2} size={12} container mt={1}>
      <ViewBalanceTemplate />
    </Grid>
    <Grid px={2} size={12} container mt={'25px'}>
      <QuickAccessButtonTemplate />
    </Grid>
    <Grid px={2} size={12} container mt={'15px'}>
      <ChallengeButtonsTemplate />
    </Grid>
    <Grid px={2} size={12}>
      <SectionTitleTemplate />
      <LiveChallengeTemplate />
    </Grid>
    <Grid size={12}>
      <Grid px={2}>
        <SectionTitleTemplate />
      </Grid>
      <Grid
        pl={2}
        container
        rowSpacing={1}
        columnSpacing={1}
        sx={{
          overflow: 'hidden',
          overflowX: 'scroll',
          flexWrap: 'nowrap',
          width: '100%',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          pr: 2,
          '&::-webkit-scrollbar': {
            display: 'none',
          },
        }}>
        <BestTradersTemplate />
        <BestTradersTemplate />
      </Grid>
    </Grid>
    <Grid px={2} size={12}>
      <LastChallengesTemplate />
    </Grid>
  </Grid>
);
